export type SubscriptionRequestCancellationStatusKeyType =
  | 'Pending'
  | 'Rejected'
  | 'Approved'
  | 'Cancelled'
export type SubscriptionRequestCancellationStatusValueType = 1 | 2 | 3 | 4

export const SubscriptionRequestCancellationStatus: Record<
  SubscriptionRequestCancellationStatusKeyType,
  SubscriptionRequestCancellationStatusValueType
> = {
  Pending: 1,
  Rejected: 2,
  Approved: 3,
  Cancelled: 4,
}
